module.exports = __webpack_public_path__ + "r-v3/img/sticker_9.897ef9e3.svg";